import script from "./NavMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NavMenu.vue?vue&type=script&setup=true&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=351ca4f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351ca4f2"]])

export default __exports__